// 孟加拉
export default {
    dialog: {
        msgShow: "‡bvwUwd‡Kkb",
        buttonOk: 'wVK Av‡Q',
        buttonCancel: 'evwZj',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'eÜ'
    },
    employeeNumber: '‡Ukwbwkqv‡bi cwiwPwZ',
    pleaseEnterEmployeeNumber: '‡Ukwbwkqv‡bi cwiwPwZ cÖ‡ek Kivb',
    password: 'cvmIqvW©',
    pleaseEnterPassword: 'cvmIqvW© w`b',
    login: 'jM Bb',
    required: 'cª‡qvRb',
    synchronize: 'wms‡µvbvBR',
    salesOrder: 'mvwf©m wi‡cvU©',
    pleaseEnterHome: 'Kv÷gv‡ii bvg I mvwf©m wi‡cvU© w`b',
    searchFilter: 'mvP© I wdëvi',
    machineSpecifications: 'g‡Wj I †¯úwmwd‡Kkb',
    processingStatus: 'weei‡bi welq',
    processing: 'GwM‡q P‡j‡Q',
    finish: '‡kl n‡q‡Q',
    waitCountermeasures: null,
    reset: '‡dir',
    submit: '‡m›U',
    muMachineInvestigation: '‡gwkb e¨venv‡ii cwiw¯’wZ',
    logout: 'jM AvDU',
    searchDate: 'mvP© ZvwiL',
    time: 'mvP© mgq',
    basicInformation: 'Kv÷gv‡ii WvUv',
    addSalesOrder: 'A¨vW mvwf©m wi‡cvU',
    save: '‡mf',
    date: 'ZvwiL',
    pleaseSelectDate: 'ZvwiL wbe©vPb Kiæb',
    travelNumber: 'mvwf©m wi‡cvU© dvBj',
    pleaseEnterTravelNumber: 'mvwf©m wi‡cvU© dvBj bv¤^v‡i cÖ‡ek Kiæb',
    customerCode: 'Kv÷gvi †KvW',
    pleaseEnterCustomerCode: 'Kv÷gvi †KvW cÖ‡ek Kivb',
    customerName: 'Kv÷gv‡ii bvg',
    pleaseEnterCustomerName: 'Kv÷gv‡ii bvg cÖ‡ek Kivb',
    country: '‡Rjv',
    pleaseEnterCountry: '†`‡ki ‡Rjv cÖ‡ek Kivb',
    customerAddress: 'Kv¯Ugv‡ii wVKvbv',
    pleaseEnterAddress: 'Kv¯Ugv‡ii wVKvbv cÖ‡ek Kivb',
    customerContact: 'Kv¯Ugv‡ii K›Uv± cvimb',
    pleaseEnterContact: 'Kv¯Ugv‡ii K›Uv± cvimb w`b',
    salesRepresentative: 'weµq cÖwZwbwa',
    pleaseEnterSalesRepresentative: 'weµq cÖwZwbwai bvg w`b',
    hint: '‡bvwUwd‡Kkb',
    createDate: '÷vewjm ZvwiL',
    salesOrderNumber: 'wi‡cvU© dvBj bv¤^vi',
    customerSatisfaction: 'Kv÷gv‡ii mš‘wó',
    maintenancePersonnel: '‡Ukwbwkqvb',
    maintenanceTime: 'mvwf©m UvBg',
    customerConfirmation: 'Kv÷gvi Kbdvg©',
    copy: 'Kwc',
    delete: 'wWwjU',
    recordTime: null,
    machineNumber: '‡gwkb b¤^i',
    copyToSalesOrder: 'Kwc Bb',
    copyTo: 'Kwc Uz',
    selectSalesOrderNumber: 'mvwf©m wi‡cvU© wbe©vPb Kiæb',
    pleaseEnterSalesOrderNumber: 'mvwf©m wi‡cvU© dvvBj b¤^ei w`b',
    latitudeAndLongitude: 'Aÿvsk I `ªvwNgvsk',
    startMaintenance: 'mvwf©m ïiæ',
    endMaintenance: 'mvwf©m ‡kl',
    newMachine: 'BÝU‡jkb wi‡cvU',
    maintenance: '‡gwkb †givgZ',
    addMachineServiceOrder: '‡gwkb mvwf©m wi‡cvU© dvBj hy³ Kiæb',
    selectType: 'UvBc wm‡j±',
    generalMaintenance: '‡gwkb †givgZ',
    oilEducationTraining: 'IAvBGj †Uªwbs',
    pleaseEnterMachineNumber: '†gwkb bv¤^vi w`b',
    manufacturingDate: 'Drcv`‡bi ZvwiL',
    pleaseSelectManufacturingDate: 'Drcv`‡bi ZvwiL w`b',
    maintenanceWarranty: 'Iqv‡iw›Ui mg‡q mvwf©m(GK eQi)',
    underWarranty: 'Iqv‡iw›U mgqKv‡j mvwf©m',
    warrantyExpired: 'Iqv‡iw›U ‡kl',
    confirm: 'wVK Av‡Q',
    cancel: 'evwZj',
    addMaintenancePersonnel: '‡Ukwbwkqv‡bi bvg mshy³ Kiæb',
    maintenanceTimeTotal: '‡gvU mvwf‡mi mgq',
    day: 'w`b',
    hour: 'N›Uv',
    enterFactory: 'mvwf©m ïiæ',
    pleaseSelectEnterFactory: 'mvwf©m ïiæi mgq',
    longitude: '`ªvwNgvsk',
    // pleaseEnterLongitude: 'Aÿvsk w`b',
    latitude: 'Aÿvsk',
    // pleaseEnterLatitude: '`ªvwNgvsk w`b',
    leaveFactory: 'mvwf©m †kl',
    pleaseSelectLeaveFactory: 'mvwf©m †kl wm‡j± Kiæb',
    duration: '‡gvU mvwf©‡mi mgq',
    pleaseEnter: 'G›Uvi w`b',
    selectTime: 'ZvwiL I mgq w`b',
    selectSatisfaction: 'MÖvn‡Ki mš‘wó',
    verySatisfied: 'Lye mšyÍó',
    satisfied: 'mšÍyó',
    ordinary: '‡gvUvgywU',
    dissatisfied: 'Am‡šÍvó',
    veryDissatisfied: 'Lye Am‡šÍvl',
    opinionReply: 'Kv÷gv‡ii gšÍe¨',
    takePhoto: 'Qwe Zzjyb',
    uploadFile: 'dvBj Avc‡jvW',
    audio: 'AwWI dvBj',
    video: 'wfwWI dvBj',
    electronicSignature: 'Kv÷gv‡ii ¯^vÿi',
    signatureDate: '¯^vÿ‡ii ZvwiL',
    clear: 'wWwjU',
    machineInformation: '‡gwkb WvUv',
    machineFunction: '‡gwk‡bi †PwKs',
    organizationArrangement: '÷ªvKPvi I c¨vUvb©',
    spareParts: 'cvU©m&',
    operationProcedure: '†U÷ ‡iKW©',
    problemHandling: 'cÖ‡mm',
    trainee: '‡UªBwb',
    coursePlan: '‡Kvm© cøvb',
    courseSchedule: '‡Kvm© wkwWDj',
    inputVoltageAndCurrent: 'G›Uvi ‡fv‡ëR/ B‡jw±ªK Kv‡i›U G¨vw¤úqvi',
    lowSpeed: '‡¯øv w¯úW',
    highSpeed: 'nvB w¯úW',
    accelerationDecelerationSlope: 'Gw·jv‡iU / wWGw·jv‡iU i¨v¤ú',
    acceleration: 'Gw·jv‡iU i¨v¤ú',
    deceleration: 'wWGw·jv‡iU i¨v¤ú',
    clothRoller: '†UK Avc wm‡÷g Acv‡ikb',
    left: '†jd&U',
    center: 'wg‡Wj',
    right: 'ivBU',
    yarnFeedingTeeth: '†KvqvwjwU wMqvi / cywj',
    saddleRingDistance: 'K¨vg †nvìvi wis I †d«‡gi ga¨eZ©x `~iZ¡',
    yarnNozzleNumber: 'Bqvb© K¨vwiqvi',
    height: 'D”PZv',
    spacing: '`~iZ¡',
    warpYarnInfo: '‡MÖ †dweªK',
    inch: 'BwÂ',
    cm: '‡mw›UwgUvi',
    timeSequence: 'UvBwgs',
    needle: 'wb‡Wj',
    yarnSpecification: 'myZvi weeiwb',
    yarn: 'myZv',
    serialNumber: 'Ab¨vb¨ †gwkb bv¤^vi',
    technician: '‡Ukwbwkqvb',
    series: '‡dewiK wmwiR',
    fabricType: '‡dewiK UvBc',
    productFeatures: '‡cÖvWv± wdPvi',
    inputVoltage: 'G›Uvi ‡fv‡ëR',
    inputCurrent: 'G¨vw¤úqvi w`b',
    electronicWindingTensionUpper: '‰e`¨ywZK †ivjvi G¨vw¤úqvi(Avcvi)',
    electronicWindingTensionLower: '‰e`¨ywZK †ivjvi G¨vw¤úqvi(‡jvqvi)',
    mechanicalType: '‡gKvwbK¨vj †ivjvi wMqvi',
    lowerNeedleDistanceToSeatRing: 'K¨vg †nvìvi wis I wmwjÛv‡ii ga¨eZ©x `~iZ¡',
    upperNeedleDistanceToSeatRing: 'Wvqvj I K¨vg †nvìv‡ii ga¨eZ©x `~iZ¡',
    upperNeedleDistanceToLowerNeedleNozzle: 'Wvqvj I wmwjÛvi bK-Ifvi G‡Ri ga¨eZ©x M¨vc',
    selectorNeedleRingDistanceToTakeUpPlate: 'G¨vKPz‡qUi wis Ges †d«‡gi« ga¨eZ©x `~iZ¡',
    seatRingDistanceToTakeUpPlate: 'K¨vg †nvìvi wis Ges †d«‡gi« ga¨eZ©x `~iZ¡',
    machineSpeed: '†gwkb AviwcGm',
    inverterFrequency: 'BbfvU©v†ii nvW©R',
    yarnCount: 'wmwcAvB',
    gramsPerSquareMeter: 'wRGmGg',
    yardsPerPound: '‡MÖ / WvBW Bqvb©',
    customerYarnWidth: '‡dweªK DB_',
    customerSpecifiedYarnLength: 'w÷P †jš’ cwigvc',
    newCustomerPackageTiming: 'wmsKvi UvBwgs',
    doubleSidedCuttingTiming: 'Wvqvj K¨vg UvBwgs',
    nozzleTiming: 'Bqvb© K¨vwiqvi UvBwgs',
    yarnCode: 'Bqvb© †KvW',
    yarnType: 'myZvi weeib',
    color: 'myZvi is',
    yarnSize: 'myZvi KvD›U',
    fiberCount: 'wdjv‡g›U',
    innerFiber: 'cvB‡ji wfZ‡i',
    outerFiber: 'cvB‡ji evwn‡i',
    flatness: '‡j‡fj‡bm',
    roundness: 'ivDÛ‡bm',
    windPressure: 'Gqvi †cÖkvi',
    appearance: 'G¨vwcqv‡iÝ',
    machineLevel: '‡gwkb †d‡gi †j‡fj‡bm',
    trident: 'Wvqvj †d«g †j‡fj‡bm I ivDÛ‡bm',
    highLegWinder: 'nvB †jM †UK Avc',
    fabricSlitting: 'I‡cb DB_ †UK Avc',
    inverterCurrent: 'BbfvU©vi G¨vw¤úqvi',
    machineFunctionFrame: 'Bqvb© GgwcGd Ges wis Ges wµj',
    inchStart: 'RM, ÷vU©¢ Ges ÷c myBP dskb',
    firstSecondSpeed: 'w¯úW, j¨v¤ú I d¨vb myB‡Pi dvskb',
    firstSecondSpeed2: 'w¯úW †mwUs dvskb',
    controllerOtherFunctions: 'K‡›Uªvjv‡ii Ab¨vb¨ dvskb',
    electricalBoxSignals: 'wmMbvj I †mbmi',
    fanDustRemovalAction: 'd¨vb Acv‡ikb',
    oilSprayerAction: 'I‡qjv‡ii Acv‡ikb',
    airBlowerSystemAction: 'Gqvi †cÖkvi I Acv‡ikb',
    windingAction: '‡UK Avc wm‡÷‡gi Acv‡ikb',
    machineControllerOperationTutorial: 'K‡›Uªvj c¨v‡bj Acv‡ikb ‡Uªwbs',
    machineOperationTutorial: '‡gwkb Acv‡ikb ‡Uªwbs',
    other: 'Ab¨vb¨',
    descriptionAndAttachment: 'D`vnib',
    upperNeedleArrangement: 'Wvqvj wb‡Wj AW©vi',
    upperKnifeArrangement: 'Wvqvj bvBd AW©vi',
    lowerNeedleArrangement: 'wmwjÛvi wb‡Wj AW©vi',
    lowerNeedleArrangementShort: 'wmwjÛvi wb‡Wj AW©vi',
    lowerKnifeArrangement: 'wmwjÛvi bvBd AW©vi',
    lowerKnifeArrangementShort: 'wmwjÛvi bvBd AW©vi',
    upperNeedlePlate: 'Wvqvj',
    lowerNeedleCylinder: 'wmwjÛvi',
    blank: '‡¯úm',
    blockRule: '‡gRvi wRMm&',
    retractionBaseline: 'wb‡Wj wW‡÷Ý e¨vK',
    upperPlateNeedleWithdrawalKnob: 'Wvqvj †¯‹j be',
    upperPlateNeedleWithdrawalDepth: 'Wvqvj w÷‡Pi `~iZ¡',
    upperPlateHalfNeedleHeight: 'Wvqvj bxU I UvK K¨v‡gi `~iZ¡',
    upperPlateFlatNeedleHeight: 'Wvqv‡ji wgm K¨v‡gi `~iZ¡',
    lowerCylinderFlatNeedleHeight: 'wmwjÛvi wgm K¨v‡gi `~iZ¡',
    lowerCylinderFlatNeedleDepth: 'wmwjÛvi w÷‡Pi `~iZ¡',
    lowerCylinderNeedleWithdrawalKnob: 'wmwjÛvi †¯‹j be',
    yarnTypeCode: 'Bqvb© †KvW',
    yarnTypeTensionN: 'Bqvb© ‡Ubkb(Gb)',
    cmPer100Needles: 'Bqvb© w÷P †jš’/ 100 wb‡Wj',
    feedYarnLengthPerRevolution: 'Bqvb© w÷P †jš’/ 1 †Kvm©',
    aluminumPlateYarnFeedingDepthCm: '‡KvqvwjwU cywj Wvqv(wmGg)',
    yarnFeedingAluminumPlateScale: '‡KvqvwjwV cywj gvK©',
    newCustomerPackage: 'wmsKvi',
    upperPlate: 'Wvqvj',
    lowerCylinder: 'wmwjÛvi',
    yarnShort: 'Bqvb©',
    pleaseEnterProductName: 'cvU©‡mi weeib w`b',
    pleaseEnterProductNumber: 'cvU©‡mi bv¤^vi w`b',
    quantity: 'cwigvb',
    damage: 'fvOv',
    missing: 'cvIqv hvqwb',
    wrong: 'fzj',
    pleaseEnterTitle: 'wk‡ivbvg w`b',
    pleaseEnterContent: 'cwigvb w`b',
    addQuestionItem: 'cÖkœ hy³ Kiæb',
    questionProcessingRecord: 'KvD›Uvi cwigvc †iKW©',
    pleaseEnterQuestionDescription: null,
    traineeAndClient: 'wkÿvbwek / Kv÷gvi',
    trainer: 'cÖwkÿK',
    drawingFunction: 'K¨v‡Wi dvskb',
    upperMachineProgram: '‡gwk‡bi ‡cÖvMvg',
    UnravelingFunction: 'Kvco we‡kølb',
    courseName: '‡Kv‡m©i bvg',
    pleaseEnterCourseName: '‡Kv‡m©i bvg w`b',
    imageName: 'c¨vUvb© dvB‡ji bvg',
    pleaseEnterImageName: 'c¨vUvb© dvB‡ji bvg w`b',
    confirmItem: 'wbwðZ',
    undone: 'Amgvß',
    pleaseEnterInquire: 'Kv÷gv‡ii bvg w`b, GgBD WKz‡g›U bv¤^vi',
    machineUtilizationSurvey: '‡gwk†bi e¨venvi Dc‡hvwMZv',
    customerID: 'Kv÷gv‡ii cwiwPwZ',
    pleaseEnterCustomerID: 'Kv÷gv‡ii cwiwPwZ w`b',
    pleaseSelect: 'wm‡j± Kiæb',
    pleaseEnterSkill: '`ÿZv Rvbvb',
    pleaseEnterBuyer: '‡µZv cwiwPwZ w`b',
    pleaseEnterRemark: 'gšÍe¨ Rvbvb',
    source: null,
    selfInput: '自行輸入',
    textileEquipment: 'wbwUs †gwkb',
    textileMachineBrand: 'wbwUs †gwkb eªvÛ',
    textileMachineType: 'wbwUs †gwkb g‡Wj',
    notSelected: null,
    select: 'wba©vib',
    brand: 'eªvÛ',
    totalMachine: null,
    openRate: null,
    dailyOutput: null,
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'mgš^‡qi welq e¯‘ †jLyb',
    // alert
    editNotSave: '‡ei nevi e¨vcv‡i wbðZ?',
    deleteConfirm: 'Avcwb wK wbwðZ fv‡e gyQ‡Z Pvb?',
    confirmClearSignature: 'Avcwb wK ¯^vÿi msµvšÍ WvUv gyQ‡Z Pvb?',
    confirmWriteData: 'Avcwb wK Z_¨ wjL‡Z wbwðZ?',
    confirmCopyToSalesOrder: 'Avcwb wK Z‡_¨i WvUv mvwfm wi‡cv‡U© wjL‡Z Pvb?',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: 'mdj fv‡e gy‡Q‡Q',
    clearSuccess: 'mdj fv‡e m‡i‡Q',
    copySuccess: 'Kwc mdj',
    selectWorker: '‡Ukwbwkqvb wm‡j± Kiæb',
    selectProblem: 'cÖkœ wm‡j± Kiæb',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'ZvwiL wbe©vPb Kiæb',
    yarnTensionN: 'Bqvb© ‡Ubkb(Gb)',
    category: 'aib',
    kind: 'g‡Wj',
    // pleaseSelectType: 'UvBc wm‡j±',
    dateInOutError: 'mvwf©m mgvcwb ZvwiL I ciewZ© mvwfm †WU GKB n‡e',
    yarnFeedingTeethOrDisc: '†KvqvwjwU wMqvi / cywj',
    changed: null,
    pleaseSelectSparePartsStatus: 'hš¿vs‡ki Ae¯’v wm‡j± Kiæb',
    pleaseEnterDuration: 'G›Uvi w`b ‡gvU mvwf©‡mi mgq',

    // API語系
    saveComplete: '‡mf mvK‡mmdzj',
    needOnline: 'Need Online.',
    addComplete: 'G¨vW mvK‡mmdzj',
    reportCreator: 'wi‡cvU© wµ‡qUi',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: 'Synchronize Fail.',
    synchronizeSuccess: 'wms‡µvbvBuuuR mvK‡mmdzj',
    downloadFail: 'Download Fail.',
    downloadSuccess: 'WvDb‡jvW mvK‡mmdzj',
    synchronizeSelect: 'wms‡µvbvBR wm‡j±',
    onlySynchronizeOffData: 'WvDb‡jvwWs AbjvBb WvUv',
    synchronizeData: 'wmswKs AdjvBb WvUv',
    synchronizeImage: 'wms‡µvbvBuuuR Buu†gR',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'AdjvBb WvUv WvDb‡jvW',
    downloadOfflineImage: 'AdjvBb B‡gR WvDb‡jvW',
    synchronizing: 'wms‡µvbvBwRs n‡”Q, A‡cÿv Kiæb| G¨vc w¯Œb eÜ Ki‡eb bv|',
    downloading: 'WvDb‡jvW n‡”Q, A‡cÿv Kiæb| G¨vc w¯Œb eÜ Ki‡eb bv|',
    confirmDownload: 'WvDb‡jvW Kbdvg© K‡i‡Qb wK?',
    confirmSynchronization: 'wms‡µvbvBR Kbdvg© K‡i‡Qb wK?',
    overwriteOffline : 'AdjvBb WvUvi Dci WvDb‡jvW Ifvi ivBU n‡e|',
    synchronizationOnline: 'The synchronization will sync the online related data.',
    uploadFail: 'Upload failed.',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'G¨v‡iÄ evB wµ‡qU AW©vi',
    sortByType: 'G¨v‡iÄ evB UvBc',
    reportDownload: 'রিপোর্ট',
    selectServiceReport: 'সেবা প্রতিবেদন নির্বাচন করুন',
    enterServiceReportOrMachine: 'সেবা প্রতিবেদন নম্বর বা মেশিন নম্বর টাইপ করুন',
    selectAll: 'সবগুলো নির্বাচন করুন',

    downloadHint:null
}
